import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import useDragScroll from '~/hooks/useDragScroll';
import useWindowSize from '~/hooks/useWindowSize';

import { calcVw } from '~/styles/helpers';

const StickyContainer = styled.div`
    position: relative;
    width: ${calcVw(100)};
    overflow: hidden;
    left: 50%;
    right: 50%;
    margin: 0 ${calcVw(-50)};
`;

const ScrollableContainer = styled.div`
    width: ${calcVw(100)};
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    cursor: grab;
    touch-action: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: ${({ theme }) => theme.layout.containerWidth}) {
        margin: 0 ${calcVw(-50)};
        left: 50%;
        right: 50%;
        position: relative;
    }
`;

const OffScreenScroller = ({ children, className }) => {
    const windowSizes = useWindowSize();
    const [ref] = useDragScroll(!windowSizes.includes('tablet'));

    return (
        <StickyContainer>
            <ScrollableContainer {...{ className }} {...{ ref }}>
                {children}
            </ScrollableContainer>
        </StickyContainer>
    );
};

OffScreenScroller.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

export default OffScreenScroller;
